import en from './en';
import es from './es';
import fr from './fr';
import { DEFAULT_LANGUAGE, normalizeLanguage } from './languages';

const CATALOGS = { en, es, fr };

function getByPath(source, key) {
    if (!source || !key) {
        return undefined;
    }
    return key.split('.').reduce((acc, part) => (
        acc && acc[part] != null ? acc[part] : undefined
    ), source);
}

function applyVars(value, vars) {
    if (!vars) {
        return value;
    }
    return String(value).replace(/\{(\w+)\}/g, (match, name) => (
        vars[name] != null ? String(vars[name]) : match
    ));
}

export function translate(language, key, vars) {
    const lang = normalizeLanguage(language) || DEFAULT_LANGUAGE;
    let value = getByPath(CATALOGS[lang], key);
    if (value == null && lang !== DEFAULT_LANGUAGE) {
        value = getByPath(CATALOGS[DEFAULT_LANGUAGE], key);
    }
    if (value == null) {
        return key;
    }
    return applyVars(value, vars);
}
